import { createReducer } from 'redux-act';
import * as actions from '../actions/jobs';

interface JobItem {
  percent: number | undefined;
}

type JobsState = Record<string, JobItem>;

const initialState: JobsState = {};

const handleCreateJob = (state: JobsState, id: string | number): JobsState => {
  if (typeof id === 'string' || typeof id === 'number') {
    const next = { ...state };
    next[id] = { percent: 0 };
    return next;
  }
  return state;
};

const handleUpdateJob = (state: JobsState, payload: unknown): JobsState => {
  const id = Array.isArray(payload) ? payload[0] : payload;
  const percent = Array.isArray(payload) ? payload[1] : undefined;
  if (typeof id === 'string' || typeof id === 'number') {
    const next = { ...state };
    next[id] = { percent };
    return next;
  }
  return state;
};

const handleRemoveJob = (state: JobsState, id: string | number): JobsState => {
  if (typeof id === 'string' || typeof id === 'number') {
    const next = { ...state };
    delete next[id];
    return next;
  }
  return state;
};

export default createReducer<JobsState>(
  {
    [actions.handleCreateJob as any]: handleCreateJob,
    [actions.handleUpdateJob as any]: handleUpdateJob,
    [actions.handleRemoveJob as any]: handleRemoveJob,
  },
  initialState
);

///
// import {createReducer} from 'redux-act'
// import * as actions from '../actions/jobs'

// let jobs = {
// };

// const handleCreateJob = (state, id) => {

//   if(typeof id === 'string' || typeof id === 'number')
//   {
//     state[id] = {percent: 0};

//     return state
//   }else{
//     return state;
//   }
// }

// const handleUpdateJob = (state, id, percent) => {

//   if(typeof id === 'string' || typeof id === 'number')
//   {
//     state[id] = {percent: percent};

//     return state
//   }else{
//     return state;
//   }
// }

// const handleRemoveJob = (state, id) => {

//   if(typeof id === 'string' || typeof id === 'number')
//   {
//     delete state[id];

//     return state
//   }else{
//     return state;
//   }
// }

// const reducer = createReducer({
//   [actions.handleCreateJob]: handleCreateJob,
//   [actions.handleUpdateJob]: handleUpdateJob,
//   [actions.handleRemoveJob]: handleRemoveJob,
// }, jobs)

// export default reducer
